import { EnterprisesListDto } from "../auth/dto/enterprise-list.dto";
import { ResponseCachedDecorator } from "./decorators/response-cached.decorator";
import { ResponseResultTypeDecorator } from "./decorators/response-result-type.decorator";
import { GenericServiceResponse } from "./generic-service-response";

@ResponseCachedDecorator()
@ResponseResultTypeDecorator(EnterprisesListDto)
export class EnterpriseListResponse extends GenericServiceResponse<EnterprisesListDto> {

}